<template>
  <v-app>
    <v-main>
      <div class="my-10 bg-secondary ma-auto pa-10">
        <div
          class="text-h4 text-center text-lg-h2 my-5"
          style="font-family: togebarabold, sans-serif;"
        >
          「アパシー 男子校であった怖い話」<br />実況・動画配信のガイドライン
        </div>
        <v-img
          :width="800"
          aspect-ratio="16/9"
          cover
          src="http://d-mebius.com/apathyboy/img/ss_st.jpg"
          class="ma-auto"
        ></v-img>
        <p
          style="text-align: center; line-height: 1.5em;"
          class="text-h6 pa-3 w-75 ma-auto"
        >
          「アパシー
          男子校であった怖い話」はアドベンチャーというゲームの性質上、<br />実況や動画による配信で物語のネタバレをしてしまうことがございます。<br />
          たくさんの方に楽しんでもらいたいという制作側の意図がございますので、<br />下記に実況・動画配信に関してのガイドラインを制定させて頂きます。
        </p>
        <div class="d_area">
          <p>
           ◆本編のすべてのEDまでの実況動画投稿・配信を許可します。</p>
           <p>
          ◆「アパシー 鳴神学園七不思議」連動シナリオの実況及び配信は禁止とさせていただきます。
          </p>

          <hr />
          <p>
            ◆キャプション等に下記の権利表記の記載をしてください。<br />
            <span
              style="
                text-decoration: underline;
                text-decoration-color: #fff000;
              "
              >©飯島多紀哉. ©Shannon. Developed&Published by mebius.</span
            ><br />
            もしくは<br /><span
              style="
                text-decoration: underline;
                text-decoration-color: #fff000;
              "
              >©Takiya Iijima. ©Shannon. Developed&Published by mebius.</span
            >
          </p>
          <p>
            ◆動画や配信で他者を誹謗中傷している場合や公序良俗に反していると判断した場合、
            動画の削除や配信中止のお願いをすることがございます。
          </p>
        </div>
        <p
          style="text-align: center; line-height: 1.5em;"
          class="text-h6 pa-3 w-75 ma-auto"
        >
          実況配信に関しまして、常識の範囲内であれば基本的に何をやって頂いても問題ございません。<br />
          なお、ゲームや開発・販売会社、クリエイターの品位・信用を損ねるものはご遠慮ください。
        </p>
      </div>
      <AppFooter />
      <!-- footerコンポーネントの使用 -->
    </v-main>
  </v-app>
</template>

<script>
  import AppFooter from "./AppFooter.vue";
  export default {
    components: {
      AppFooter,
    },
  };
</script>

<style scoped>
  .d_area {
    border: #fff solid 1px;
    padding: 2em;
    margin: 2em auto !important;
    line-height: 2.5em;
    width: 80%;
  }
  .d_area p {
    margin: 1em auto;
  }
</style>
